module.exports = __webpack_public_path__ + "img/logo_telegram.a95782bc.svg";